import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import './Otherservices.css';

// Helper icons mapping based on service name
const getServiceIcon = (name) => {
    const lower = (name || '').toLowerCase();
    if (lower.includes('chartered') || lower.includes('ca') || lower.includes('audit')) {
        return 'fa-calculator';
    } else if (lower.includes('law') || lower.includes('legal')) {
        return 'fa-balance-scale';
    } else if (lower.includes('digital') || lower.includes('marketing') || lower.includes('seo')) {
        return 'fa-bullhorn';
    } else if (lower.includes('public') || lower.includes('pr')) {
        return 'fa-handshake';
    }
    return 'fa-briefcase';
};

const Otherservices = () => {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [openServiceIds, setOpenServiceIds] = useState([1]); // First service open by default

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const response = await fetch('https://api.ndtechland.com/api/HomeApi/GetOtherServices');
                if (!response.ok) {
                    throw new Error('Failed to fetch services');
                }
                const { data } = await response.json();
                setServices(data || []);
                if (data && data.length > 0) {
                    setOpenServiceIds([data[0].id]);
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchServices();
    }, []);

    const toggleService = (id) => {
        if (openServiceIds.includes(id)) {
            setOpenServiceIds(openServiceIds.filter(item => item !== id));
        } else {
            setOpenServiceIds([...openServiceIds, id]);
        }
    };

    if (loading) {
        return (
            <div>
                <Header />
                <div className="nd-loading-container">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3 text-muted">Loading services, please wait...</p>
                </div>
                <Footer />
            </div>
        );
    }

    if (error) {
        return (
            <div>
                <Header />
                <div className="nd-error-container">
                    <div className="alert alert-danger" role="alert">
                        <h5>Unable to load services</h5>
                        <p>{error}</p>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }

    return (
        <div className="nd-other-services-page">
            <Header />
            
            <section className="services-section">
                <div className="services-container container">
                    {/* Header Section */}
                    <div className="text-center mb-5">
                        <div className="nd-section-badge">
                            <i className="fa fa-layer-group me-2"></i>
                            <span>Comprehensive Offerings</span>
                        </div>
                        <h2 className="nd-services-main-title">
                            Other <span className="nd-gradient-text">Services</span>
                        </h2>
                        <p className="nd-services-subtitle">
                            Explore our wide range of professional, legal, chartered, and digital solutions designed to elevate your enterprise.
                        </p>
                    </div>

                    {/* Services Accordion Cards List */}
                    <div className="nd-services-accordion-wrap">
                        {services.map((serviceCategory, index) => {
                            const isOpen = openServiceIds.includes(serviceCategory.id);
                            const iconClass = getServiceIcon(serviceCategory.serviceName);

                            return (
                                <div 
                                    className={`nd-service-card ${isOpen ? 'active-card' : ''}`} 
                                    key={serviceCategory.id || index}
                                >
                                    <div 
                                        className="nd-service-card-header"
                                        onClick={() => toggleService(serviceCategory.id)}
                                        role="button"
                                        tabIndex="0"
                                    >
                                        <div className="nd-service-header-left">
                                            <div className="nd-service-icon-box">
                                                <i className={`fa ${iconClass}`}></i>
                                            </div>
                                            <h3 className="nd-service-name">
                                                {serviceCategory.serviceName}
                                            </h3>
                                        </div>
                                        
                                        <div className="nd-service-toggle-pill">
                                            <i className={`fa ${isOpen ? 'fa-minus' : 'fa-plus'}`}></i>
                                        </div>
                                    </div>

                                    <div className={`nd-service-collapse ${isOpen ? 'show' : ''}`}>
                                        <div className="nd-service-content-body">
                                            <div 
                                                className="nd-service-html-content"
                                                dangerouslySetInnerHTML={{ __html: serviceCategory.description }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    {/* Bottom Highlight Feature Cards */}
                    <div className="row g-4 mt-4">
                        <div className="col-lg-6">
                            <div className="nd-solution-card">
                                <div className="nd-card-icon-accent">
                                    <i className="fa fa-cogs"></i>
                                </div>
                                <h3>Tailored Solutions for Your Business</h3>
                                <p>
                                    At N D Techland, we offer tailored solutions across our services, ensuring that you receive the support and expertise required to achieve your specific objectives.
                                </p>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="nd-solution-card nd-contact-highlight-card">
                                <div className="nd-card-icon-accent nd-accent-blue">
                                    <i className="fa fa-paper-plane"></i>
                                </div>
                                <h3>Get in Touch</h3>
                                <p>
                                    Ready to take your business to the next level? Contact us today to discuss your requirements and learn more about how our services can benefit your organization.
                                </p>
                                <div className="mt-3">
                                    <Link to="/Contactus" className="nd-btn-primary">
                                        <span>Contact Us Today</span>
                                        <i className="fa fa-arrow-right ms-2"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Otherservices;
